import { defineComponent as _defineComponent } from 'vue'
import { nextTick } from "vue";
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";

interface Props {
	/**
	 * トークルーム総数。
	 */
	talkRoomCount: number;
	/**
	 * リプライ付きトークルーム総数。
	 */
	talkRoomCountWithReply: number;
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    talkRoomCount: { type: Number, required: true },
    talkRoomCountWithReply: { type: Number, required: true },
    wordSettings: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * トークルーム総数。
	 */
	talkRoomCount: number;
	/**
	 * リプライ付きトークルーム総数。
	 */
	talkRoomCountWithReply: number;
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
}
/**
 * トークルーム総数。
 */



nextTick(() => {
	// ReviCoタグマネージャー等で外部定義された関数が存在すれば発火
	// なぜ?: data属性で定義したトークルーム件数、リプライ件数を外部定義の関数から取得できるようにするため
	// eslint-disable-next-line no-undef
	if (typeof revico_communitytalk_talkroomcount_complete === "function") {
		// eslint-disable-next-line no-undef
		revico_communitytalk_talkroomcount_complete();
	}
});

const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})